import dayjs from 'dayjs'

// Variável global para armazenar a data selecionada no DatePicker
let globalSelectedDate = dayjs()

// Função para acessar a data selecionada globalmente
export const getGlobalSelectedDate = () => globalSelectedDate

// Função para definir a data selecionada globalmente
export const setGlobalSelectedDate = (date) => {
  globalSelectedDate = date
}